export default {
  data() {
    return {
      errorMessage: "",
      hasError: false,
    };
  },
  methods: {
    setError(error) {
      this.errorMessage = error;
      this.hasError = true;
    },
    clearError() {
      this.errorMessage = "";
      this.hasError = false;
    },
  },
};
